export interface Replicable<T = any> {
  replicate(): T & Replicable<T>;
}

export function isReplicable<T = any>(obj: T): obj is T & Replicable<T> {
  return typeof obj === 'object' && 'replicate' in obj && typeof obj.replicate === 'function';
}
